module.exports = __webpack_public_path__ + "img/qqicon.b8ffef75.png";